import React from 'react';

const iconProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className: 'detail-icon',
    'aria-hidden': true
};

const CalendarIcon = () => (
    <svg {...iconProps}>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M3 10h18M8 3v4M16 3v4" />
    </svg>
);

const PinIcon = () => (
    <svg {...iconProps}>
        <path d="M12 21.5s7-6.4 7-11.5a7 7 0 1 0-14 0c0 5.1 7 11.5 7 11.5z" />
        <circle cx="12" cy="10" r="2.6" />
    </svg>
);

const CutleryIcon = () => (
    <svg {...iconProps}>
        <path d="M7 3v6.2a1.8 1.8 0 0 0 3.6 0V3M8.8 9.5V21" />
        <path d="M17.2 3c-1.7 1.6-2.5 3.5-2.5 5.6 0 1.5.9 2.4 2.5 2.6V21" />
    </svg>
);

const GlassIcon = () => (
    <svg {...iconProps}>
        <path d="M7.5 3h9l-1.1 6.3a3.5 3.5 0 0 1-6.8 0L7.5 3z" />
        <path d="M12 13.5V21M8.8 21h6.4" />
    </svg>
);

function EventDetails({ onOpenMaps, onAddToCalendar }) {
    return (
        <div className="event-details" style={{ userSelect: 'none', WebkitUserSelect: 'none', msUserSelect: 'none' }}>
            <div className="detail-item clickable" onClick={onAddToCalendar}>
                <CalendarIcon />
                <div className="detail-content">
                    <p className="detail-value">Sabato</p>
                    <p className="detail-subvalue">14 novembre 2026</p>
                    <p className="detail-subvalue">Ore 20:00</p>
                </div>
                <span className="detail-arrow">›</span>
            </div>

            <div className="detail-item clickable" onClick={onOpenMaps}>
                <PinIcon />
                <div className="detail-content">
                    <p className="detail-value">MAX - Massimo Mentasti</p>
                    <p className="detail-subvalue">Via de Viti de Marco, S/N, </p>
                    <p className="detail-subvalue">Maglie, LE</p>
                </div>
                <span className="detail-arrow">›</span>
            </div>

            <div className="detail-item">
                <CutleryIcon />
                <div className="detail-content">
                    <p className="detail-value">Aperitivo di benvenuto</p>
                    <p className="detail-value">Cena</p>
                </div>
            </div>

            <div className="detail-item">
                <GlassIcon />
                <div className="detail-content">
                    <p className="detail-value">A seguire</p>
                    <p className="detail-subvalue">drink &amp; music</p>
                </div>
            </div>
        </div>
    );
}

export default EventDetails;
